import { render, staticRenderFns } from "./DataProcessingAgreement.vue?vue&type=template&id=72c13fbe&scoped=true"
import script from "./DataProcessingAgreement.vue?vue&type=script&setup=true&lang=js"
export * from "./DataProcessingAgreement.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DataProcessingAgreement.vue?vue&type=style&index=0&id=72c13fbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c13fbe",
  null
  
)

export default component.exports